export default {
    methods: {
        /**
         * @see https://github.com/eckenroed/LaravelTimezone/blob/master/laravelTimezone.js
         */
        trackTimezone() {
            const cookieName = 'user_timezone';
            var timezone = this.getCookie(cookieName);
            if (timezone) return;

            // timezone = dayjs.tz.guess();
            timezone = jstz.determine().name();
            this.setCookie(cookieName, timezone, 30);
        }
    }
};
